import { useNavigate, Link } from "react-router-dom";
import "../../css/login.css";
import LogInForm from "../../components/auth/forms/LogInForm"

const Login = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/dashboard");  // Navigate to /dashboard
  };

  return (
    <div className="full-login">
      <div className="login-home-container">
        < LogInForm />
      </div>

    </div>
  );
}

export default Login;
